import React from "react";

import timelineElements from "./timelineElements";

import { ReactComponent as WorkIcon } from "./work.svg";
import { ReactComponent as SchoolIcon } from "./school.svg";

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";

import "react-vertical-timeline-component/style.min.css";

import "./professional.css";

const Professional = () => {
    let workIconStyles = { background: "#06D6A0" }
    let schoolIconStyles = { background: "#f9c74f" }

  return (
    <section id="proffessional" className="prof">
      <h5>What are my Professional</h5>
      <h2>Experiences</h2>
      <VerticalTimeline>
        {timelineElements.map((element) => {
            
          let isWorkIcon = element.icon === "work";
          let showButton =false;
          // let showButton =
          //   element.buttonText !== undefined &&
          //   element.buttonText !== null &&
          //   element.buttonText !== "";

          return (
            <VerticalTimelineElement
              key={element.key}
              date={element.date}
              contentArrowStyle={{ borderRight: '7px solid  whitesmoke' }}
              dateClassName="date"
              iconStyle={isWorkIcon ? workIconStyles : schoolIconStyles}
              icon={isWorkIcon ? <WorkIcon /> : <SchoolIcon />}>
              <h3 className="vertical-timeline-element-title">
                {element.title}
              </h3>
              <h5 className="vertical-timeline-element-subtitle">
                {element.location}
              </h5>
              <p id="description">{element.description}</p>
              {showButton && (
                <a
                  className={`button ${
                    isWorkIcon ? "workButton" : "schoolButton"
                  }
  `}
                  href="/"
                >
                  {element.buttonText}
                </a>
              )}
            </VerticalTimelineElement>
          );
        })}
      </VerticalTimeline>
    </section>
  );
};

export default Professional;
